import {Stack, Typography} from '@mui/material';
import {MainHeader, PageWrapperLayout, Snackbar} from 'presentation/components';
import {Address} from 'presentation/components/ChangeData/Address';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {useEditFavoriteAddress} from './hooks/useEditFavoriteAddress';
import {AddressTypeV4Enum} from 'domain/usecases';

const {editAddress, saveAddress, editFavoritePlace} =
	translations['pt-br'].privateFlow.bookingFlow.location;
const {title} = translations['pt-br'].privateFlow.profile.changeData.address;

export function FavoriteAddressesEdit() {
	const {
		isMobOrTab,
		handleBack,
		onSubmit,
		openEditFavoriteAddressError,
		handleCloseEditFavoriteAddressError,
		isPatchingFavoriteAddress,
		item,
		isEditingCasaAddress,
		hasCasaAddress,
	} = useEditFavoriteAddress();

	if (!item) {
		return (
			<PageWrapperLayout title={title}>
				<MainHeader title={title} handleBack={handleBack} hideProfileMenu />
				<Stack
					paddingX={isMobOrTab ? undefined : 5}
					paddingY={isMobOrTab ? undefined : 3}
					gap={2}>
					<Typography variant="body1">{title}</Typography>
				</Stack>
			</PageWrapperLayout>
		);
	}

	return (
		<PageWrapperLayout title={editAddress}>
			<MainHeader title={editAddress} handleBack={handleBack} hideProfileMenu />
			<Stack
				paddingX={isMobOrTab ? 2 : 5}
				paddingY={isMobOrTab ? 2 : 3}
				mb={isMobOrTab ? 12 : 0}
				gap={2}>
				<Address.FormV2
					onCancel={handleBack}
					onSave={onSubmit}
					address={item}
					withoutAlertInfo
					withoutCancelButton
					responsiveButtons
					hasFavoriteAddressField={item.type !== AddressTypeV4Enum.BILLING}
					favoriteAddressDescription={item?.favoriteAddress ?? ''}
					saveLabel={saveAddress}
					loading={isPatchingFavoriteAddress}
					hasCasaAddress={hasCasaAddress}
					isEditingCasaAddress={isEditingCasaAddress}
					enableCepNotFoundError
					showAddressInfoAlert={item.type === AddressTypeV4Enum.BILLING}
				/>
			</Stack>
			<Snackbar
				open={openEditFavoriteAddressError}
				onClose={handleCloseEditFavoriteAddressError}
				message={editFavoritePlace.error}
			/>
		</PageWrapperLayout>
	);
}
